import { Platform } from 'react-native'

// Web-only Tailwind utilities, gated in one place.
//
// NativeWind's selector compiler understands only the pseudo-classes hover,
// active, focus, disabled and empty (react-native-css-interop
// `normalize-selectors`). Any other pseudo — `:focus-within`, `:focus-visible`,
// `:has()` — reaches the native runtime with an EMPTY condition set, and an
// empty set passes: the declaration collapses into the base style and paints
// permanently on every native instance. Gating in JS keeps the utilities plain
// and the class literals at the call site, so Tailwind's content scanner still
// emits the CSS for web.
export const webOnly = (utilities: string): string => (Platform.OS === 'web' ? utilities : '')

// NativeWind drops `whitespace-nowrap` on native; on web `numberOfLines` would add its own overflow styles.
export const nativeSingleLine = (): 1 | undefined => (Platform.OS === 'web' ? undefined : 1)
